import React from 'react';
import { SatCoreRegister } from '../SatCoreRegistry';

import '../css/DotMenu.less';

import { makeKeyboardAccessible } from '../utils/makeKeyboardAccessible';

const DotMenu = ({ ariaLabel, clickMenu, t } = {}) => (
  <div
    className='dot-menu'
    {...makeKeyboardAccessible(clickMenu, { ariaLabel: ariaLabel || t('moreOptions') })}>
    <div className='dot' />
    <div className='dot' />
    <div className='dot' />
  </div>
);

export default DotMenu;

SatCoreRegister('DotMenu', DotMenu);
